/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TodayAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function TodayAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/UpperSection/TodayAction"
  
}) {
let tabSelectedDateValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.date',
})
let tabSelectedTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.time_zone_id',
})
let aggregateData = fromHelpers.isToday(tabSelectedDateValueData, tabSelectedTimeZoneIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let tabIsFullWidthValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'is_full_width',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 onClick={onClick}
 data="tab.selected.date"
 data="tab.selected.time_zone_id"
 aggregate="helpers.js isToday"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={tabIsFullWidthValueData ? "Switch to today" : "Today"}
 data="tab.is_full_width"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}